import {
  compressToEncodedURIComponent as compress,
  decompressFromEncodedURIComponent as decompress,
} from "lz-string";

/* ——— текущие: полноразмерный плейлист ——— */
export const encodeTracks = (tracks) => compress(JSON.stringify(tracks ?? []));
export const decodeTracks = (str) => {
  try { return JSON.parse(decompress(str) || "[]"); }
  catch { return []; }
};

/* ——— НОВЫЕ: только массив строк с spotifyId ——— */
export const encodeIds = (ids) => compress(JSON.stringify(ids ?? []));
export const decodeIds = (str) => {
  try { return JSON.parse(decompress(str) || "[]"); }
  catch { return []; }
};
